import React, { useState } from "react";

import { Link } from "react-router-dom";
import { logout as logoutService } from "services/auth_service";

import logo from "img/FS_logotipo_beta_branco.png";
import "css/main.css";
import "css/style.css";

function Topnav() {
  const [activeTab, setActiveTab] = useState(window.location.pathname);
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

  const handleHeaderInput = (e) => {
    setMobileMenuVisible(!mobileMenuVisible);
  };

  const logout = () => {
    logoutService();
    window.location.reload();
  };

  return (
    <div className="App">
      <div className="sidebar">
        <div className="container-navbar">
          <div className="navbar-brand">
            <div className="menu-brand">
              <Link to={"/"} className="menu-item">
                <img
                  alt="Foot solution Logo"
                  src={logo}
                  style={{ width: "80%" }}
                  width="125"
                  height="45"
                />
              </Link>

              <span
                onClick={(evt) => handleHeaderInput(evt)}
                role="button"
                className="navbar-burger"
                id="burger"
              >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
              </span>
            </div>
          </div>

          <aside
            className={mobileMenuVisible ? "menu is-visible" : "menu"}
            id="nav-links"
          >
            <p className="menu-label">Geral</p>
            <ul className="menu-list">
              <li onClick={() => setActiveTab("inicio")}>
                <Link
                  className={
                    activeTab.includes("inicio") || activeTab === ""
                      ? "is-active"
                      : ""
                  }
                  to={"/inicio"}
                >
                  <span className="icon is-medium">
                    <i className="fas fa-home"></i>
                  </span>
                  Início
                </Link>
              </li>
              <li onClick={() => setActiveTab("equipas")}>
                <Link
                  className={activeTab.includes("equipas") ? "is-active" : ""}
                  to={"/equipas"}
                >
                  <span className="icon is-medium">
                    <i className="fas fa-users"></i>
                  </span>
                  {localStorage.getItem("role") === "Jogador"
                    ? "Plantel"
                    : "Plantéis"}
                </Link>
              </li>

              <li onClick={() => setActiveTab("jogos")}>
                <Link
                  className={activeTab.includes("jogos") ? "is-active" : ""}
                  to={"/jogos"}
                >
                  <span className="icon is-medium">
                    <i className="fas fa-futbol"></i>
                  </span>
                  Jogos
                </Link>
              </li>

              <li onClick={() => setActiveTab("calendario")}>
                <Link
                  className={
                    activeTab.includes("calendario") ? "is-active" : ""
                  }
                  to={"/calendario"}
                >
                  <span className="icon is-medium">
                    <i className="fas fa-calendar"></i>
                  </span>
                  Calendário
                </Link>
              </li>

              <p className="menu-label">Mercado</p>
              <li onClick={() => setActiveTab("ofertas")}>
                <Link
                  className={
                    activeTab.endsWith("ofertas") &&
                    !activeTab.endsWith("minhas-ofertas")
                      ? "is-active"
                      : ""
                  }
                  to={"/ofertas"}
                >
                  <span className="icon is-medium">
                    <i className="fas fa-gavel"></i>
                  </span>
                  Mercado
                </Link>
              </li>

              <li onClick={() => setActiveTab("minhas-ofertas")}>
                <Link
                  className={
                    activeTab.endsWith("minhas-ofertas") ? "is-active" : ""
                  }
                  to={"/minhas-ofertas"}
                >
                  <span className="icon is-medium">
                    <i className="fas fa-bookmark"></i>
                  </span>
                  {localStorage.getItem("role") === "Clube"
                    ? "As minhas vagas"
                    : "Candidaturas"}
                </Link>
              </li>
            </ul>

            <p className="menu-label">Ajuda</p>
            <ul className="menu-list">
              <li onClick={() => setActiveTab("artigos")}>
                <Link
                  className={activeTab.includes("artigos") ? "is-active" : ""}
                  to={"/artigos"}
                >
                  <span className="icon is-medium">
                    <i className="far fa-newspaper"></i>
                  </span>
                  Informações úteis
                </Link>
              </li>
            </ul>
            <ul className="menu-list">
              <li onClick={() => setActiveTab("lista-casos")}>
                <Link
                  className={
                    activeTab.includes("lista-casos") ? "is-active" : ""
                  }
                  to={"/lista-casos"}
                >
                  <span className="icon is-medium">
                    <i className="far fa-life-ring"></i>
                  </span>
                  Reportar problema
                </Link>
              </li>
            </ul>
            <p className="menu-label">O meu perfil</p>
            <ul className="menu-list">
              <li onClick={() => setActiveTab("definicoes-conta")}>
                <Link
                  className={
                    activeTab.includes("definicoes-conta") ? "is-active" : ""
                  }
                  to={"/definicoes-conta"}
                >
                  <span className="icon is-medium">
                    <i className="fas fa-cog"></i>
                  </span>{" "}
                  Definições da conta
                </Link>
              </li>
              <li>
                <Link to={"/logout"} onClick={logout}>
                  <span className="icon is-medium">
                    <i className="fas fa-sign-out-alt"></i>
                  </span>{" "}
                  Terminar sessão
                </Link>
              </li>
            </ul>
          </aside>
          <div />
        </div>
      </div>
    </div>
  );
}

export default Topnav;
